import React from "react";
import { FormItem } from "@/components/Form";
import { useTranslation } from "@/langs/useTranslation";
import SingleSelector from "../SingleSelector";
import TagList from "../FormFields/TagList";
import DeviceSerialNumberSelector from "../FormFields/DeviceSerialNumberSelector";
import DeviceGroups from "../FormFields/DeviceGroups/DeviceGroups";

const ScheduleSelectType = props => {
  const {
    groupId,
    setGroupId,
    setSelectType,
    selectType,
    tagId,
    setTagId,
    device,
    setDevice
  } = props;
  const { t } = useTranslation("deviceControl");

  const handleChangeTags = e => {
    setTagId(e.target.value);
  };

  const handleChangeGroups = e => {
    setGroupId(e.target.value);
  };

  const handleChangeDevice = e => {
    setDevice(e.target.value);
  };

  const handleChangeType = e => {
    const type = e.target.value;
    setSelectType(type);
    // if (type === "group") {
    //   setGroupId([]);
    // }
    // if (type === "tag") {
    //   setTagId([]);
    // }
    setGroupId([]);
    setTagId([]);
    setDevice({});
  };

  const typeHandler = () => {
    switch (selectType) {
      case "group":
        return (
          <FormItem label={t("common.selectDeviceGroup")}>
            <DeviceGroups
              clearable={false}
              value={groupId[0] === "all" ? [] : groupId}
              onChange={handleChangeGroups}
            />
          </FormItem>
        );
      case "tag":
        return (
          <FormItem label={t("common.selectDeviceTag")}>
            <TagList
              clearable={false}
              value={tagId}
              onChange={handleChangeTags}
            />
          </FormItem>
        );
      case "device":
        return (
          <FormItem label={t({ defaultMessage: "选择设备" })}>
            <DeviceSerialNumberSelector
              value={device}
              onChange={handleChangeDevice}
            />
          </FormItem>
        );
      default:
        break;
    }
  };

  return (
    <>
      <FormItem label={t("common.selectType")}>
        <SingleSelector
          value={selectType}
          onChange={handleChangeType}
          clearable={false}
          placeholder={t("common.selectType")}
          options={[
            { id: "group", name: t({ defaultMessage: "门店" }) },
            { id: "tag", name: t({ defaultMessage: "标签" }) },
            { id: "device", name: t({ defaultMessage: "设备" }) }
          ]}
        />
      </FormItem>
      {typeHandler()}
    </>
  );
};

export default ScheduleSelectType;
